export const namespaced = true

export const state = {
    mobile:"",
    email:"",
    otp_token:"",
    action:"",
    step:1,
}

export const mutations = {
    SET_OTP_TOKEN(state, { otp_token, mobile, email,action}){
        state.otp_token = otp_token
        state.mobile = mobile
        state.email = email
        state.action = action
        console.log({state})
    },
    SET_AUTH_STEP(state, step){
        state.step = step
    },
}

export const actions = {
    setOtpToken({commit}, items){
        commit('SET_OTP_TOKEN', items)
    },
    setAuthStep({commit}, items){
        commit('SET_AUTH_STEP', items)
    },

}
export const getters = {
    getOtpToken:state=>{
        return state;
    },
    getAuthStep:state=>{
        return state.step;
    },
}